module.exports = __webpack_public_path__ + "img/catchbasin_parked.0c233481.svg";